// ABOUTME: Central color definitions for the application.
// ABOUTME: All UI components should import colors from here for consistency.

export const colors = {
  // Primary palette - used across the app
  palette: {
    orange: '#F97B2C',
    orangeDark: '#D66520',
    pink: '#F43F7A',
    pinkDark: '#C43162',
    magenta: '#D946EF',
    magentaDark: '#A835BA',
    purple: '#7C3AED',
    purpleDark: '#5B2BB0',
    green: '#34D399',
    greenDark: '#2A9D6E',
    cyan: '#5CE1E6',
    cyanDark: '#48B3B8',
    blue: '#3B82F6',
    blueDark: '#2563EB',
  },

  // Schedule section colors
  schedule: {
    planned: '#34D399',
    plannedDark: '#2A9D6E',
    urgent: '#F97B2C',
    urgentDark: '#D66520',
    stock: '#3B82F6',
    stockDark: '#2563EB',
    ignored: '#9CA3AF',
    ignoredDark: '#6B7280',
  },

  // Category fallback color (actual colors come from backend config)
  category: {
    default: '#9E9E9E',
  },

  // Text colors
  text: {
    primary: '#1f2937',
    secondary: '#6b7280',
    muted: '#9ca3af',
  },

  // Background colors
  background: {
    white: '#ffffff',
    light: '#f3f4f6',
    hover: '#fafafa',
    sidebar: '#F2F2F2',
  },

  // Border colors
  border: {
    light: '#e5e7eb',
    lighter: '#f3f4f6',
  },

  // Status colors
  status: {
    error: '#F43F7A',
    warning: '#F97B2C',
    success: '#34D399',
    info: '#5CE1E6',
  },

  // UI element colors
  ui: {
    button: '#1f2937',
    buttonHover: '#374151',
    accent: '#F97B2C',
  },
};

export default colors;
